/**
 * Returns true when a Supabase/PostgREST error indicates the table or view
 * doesn't exist (or isn't accessible). Used for graceful degradation when
 * schema migrations haven't been applied yet.
 */
export function isTableMissingError(
  error: { code?: string; message?: string } | null
): boolean {
  if (!error) return false;
  return (
    error.code === '42P01' ||                       // PostgreSQL: undefined_table
    error.code === '42501' ||                       // PostgreSQL: insufficient_privilege
    !!error.code?.startsWith('PGRST') ||            // PostgREST schema-cache miss
    !!error.message?.includes('does not exist')
  );
}
